import { Component,Input,OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {AuthenticationService } from 'src/app/shared/services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  
  addLoginForm = this.formBuilder.group({
    email: ['', [
        Validators.required
    ]],
    password: ['', [
        Validators.required
    ]]
});
  // addLoginForm: UntypedFormGroup;
  showResult = false
  showPassword = false

  @Input() thirPartyLogin = true

  constructor(private formBuilder: UntypedFormBuilder,
    private auth: AuthenticationService, private router: Router) {}

  ngOnInit() {
     
  }
  get addLf() { return this.addLoginForm.controls; }
  login() 
    {
      if(this.addLoginForm.valid)
      {
        this.auth.signin(this.addLoginForm.value).subscribe((res:any)=>{
          console.log(res);
          localStorage.setItem('email',res.email);
          localStorage.setItem('username',res.name);
          localStorage.setItem('token', res.token);
          localStorage.setItem('profileImg', this.auth.apiUrl+'/uploads/'+res.profileImg);
          // this.toastr.success('', 'Login Successfully!');

          // we are adding this just for managing user role
      sessionStorage.setItem('user', JSON.stringify(res));
      // 

          this.router.navigateByUrl('/dashboard');
        },(err:any)=>{
          console.log(err);
          // this.toastr.error('', err.error.message);
        })
      }
    }

  onShowPasswordClick () {
      this.showPassword = !this.showPassword
  }

  onReset() {
      this.addLoginForm.reset();
  }

}
